































































import tipoDeficienciaService from '@/api/tipo-deficiencia.service';
import { Component, Vue } from 'vue-property-decorator';
import { Message } from '../../model/generic/message';
import { TipoDeficiencia } from '../../model/tipo-deficiencia';
import Multiselect from 'vue-multiselect';

@Component({
    props: { tipoDefProp: Object }
})
export default class EditarTipoDeficiencia extends Vue {

    public tipo: TipoDeficiencia;
    public tiposDeficienciaGerais: Array<TipoDeficiencia>;

    public campos: Array<Object> = [
      {
        key: 'descricao',
        label: 'Deficiência Específica',
        sortable: true
      },
      {
        key: 'acoes',
        label: 'Ações',
        tdClass: 'acoes-1',
        thClass: 'acoes-1'
      }];

    constructor(){
        super();
        if (this.$props.tipoDefProp != null) {
            this.tipo = this.$props.tipoDefProp;
        } else {
            this.tipo = new TipoDeficiencia(null, "", null)
        }
        this.tiposDeficienciaGerais = Array.of();
        this.carregarTiposDeficienciaGerais();
    }

    async carregarTiposDeficienciaGerais () {
        let tiposDeficiencia = await tipoDeficienciaService.listarGerais();
        if (tiposDeficiencia != null) {
            this.tiposDeficienciaGerais = tiposDeficiencia.registros;
        }
    }

    async salvar () {
        let result = await this.$validator.validateAll();
        if (result) {
            let retorno = await tipoDeficienciaService.salvar(this.tipo);
            if (retorno != null) {
                this.$router.push({
                    name: 'listar-tipo-deficiencia'
                });
                this.$store.commit('setMessages', new Message('Registro salvo com sucesso', 'success'));
            }
        }
    }

    voltar () {
        this.$router.push({
            name: 'listar-tipo-deficiencia'
        });
    }
}
